
<svg xmlns="http://www.w3.org/2000/svg" width="31" height="23.117" viewBox="0 0 31 23.117">
    <path d="M10.529,27.24.454,17.165a1.55,1.55,0,0,1,0-2.192l2.192-2.192a1.55,1.55,0,0,1,2.192,0l6.787,6.787L26.162,5.031a1.55,1.55,0,0,1,2.192,0l2.192,2.192a1.55,1.55,0,0,1,0,2.192L12.721,27.24A1.55,1.55,0,0,1,10.529,27.24Z" transform="translate(0 -4.577)" fill="#7dc983"/>
</svg>
  